import TicketsDashboard from './Dashboard';

export default TicketsDashboard;
